/**
 * The cockpit's three columns: chat, the picture, the line-up. The stage renders
 * the camera above the router, so it and the page have to agree on where the
 * middle is — one set of class strings, used by both.
 */
export const CHAT_COLUMN = "lg:w-[16rem] xl:w-[18.75rem]";
export const SIDE_COLUMN = "sm:w-[22rem] xl:w-[25rem]";
export const PICTURE_FRAME = "sm:right-[22rem] lg:left-[16rem] xl:right-[25rem] xl:left-[18.75rem]";
